/*
 * @Author: Dong
 * @Date: 2022-04-07 13:22:58
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-28 09:57:14
 */
import React, { createRef } from 'react';
import { useIntl } from 'react-intl';
import Icon from 'root/components/Icon';
import Form from './Form';
import messages from './messages';
import styles from './index.less';
import classnames from 'classnames';
import { FormComponentProps } from 'sup-ui/lib/form';
import { PackageDataType } from '../types';
// import { useSelector } from 'react-redux';
// import { reducerStates } from 'root/store/types';

interface PropsType extends PackageDataType {
  version: string;
  selectedVersions: any;
  cancelUpload: any;
  fileName: string;
  archiveId: string;
  handleDelete: (packageName: string) => void;
  handleRetry: (data: any) => void;
  retestCheck: (props: any) => void;
  isAvailable?: boolean;
  checkDetail?: string;
  isCurrent: number;
  updateMethod: number;
  operationType: string;
}

const Package = (props: PropsType) => {
  const {
    name,
    img,
    title,
    subTitle,
    type,
    status,
    uploadPrecent,
    disabled,
    form,
    version,
    cancelUpload,
    fileName,
    handleDelete,
    handleRetry,
    retestCheck,
    archiveId,
    checkDetail,
    isAvailable,
    isCurrent,
    // updateMethod,
    // operationType,
  } = props;

  const intl = useIntl();
  const formRef = createRef<FormComponentProps>();
  const i18nTitle = title && typeof title === 'object' ? intl.formatMessage(title) : title;
  // const { cluster } = useSelector((state: reducerStates) => state.envManage);

  const statusRender = () => {
    switch (status) {
      case 'CHECKING':
        return <div className={styles.success}>{intl.formatMessage(messages.checking)}</div>;
      case 'UPLOADING':
        return (
          <div className={styles.waiting}>
            <span>{intl.formatMessage(messages.uploading)}</span>
            <span className={styles.progress}>
              <Icon type="sync" />
              {uploadPrecent}%
            </span>
            <span className={styles.cancel} onClick={() => cancelUpload(name, version)}>
              {intl.formatMessage(messages.cancel)}
            </span>
          </div>
        );
      case 'UPLOAD_FAIL':
        return (
          <div className={styles.fail}>
            <span className={styles.failReson}>{intl.formatMessage(messages.uploadFail)}</span>
            <Icon type="help16" styles={{ fontSize: 16, color: '#D20C0C' }} />
            <span onClick={() => handleRetry(props)} className={`${styles.cancel} ${styles.progress}`}>
              {intl.formatMessage(messages.retry)}
            </span>
            <span className={styles.cancel} onClick={() => handleDelete(fileName)}>
              {intl.formatMessage(messages.delete)}
            </span>
          </div>
        );
      case 'CHECK_FAIL':
        return (
          <div className={styles.fail}>
            <span className={styles.failInfo}>
              <span className={styles.failReson}>{intl.formatMessage(messages.checkFail)}</span>
              <span className={styles.detail}>{intl.formatMessage(messages.detail)}</span>
            </span>
            <span onClick={() => retestCheck(props)} className={styles.progress}>
              {intl.formatMessage(messages.retest)}
            </span>
            <span className={styles.cancel} onClick={() => handleDelete(fileName)}>
              {intl.formatMessage(messages.delete)}
            </span>
          </div>
        );
      default:
        return null;
    }
  };

  const classname = classnames(`${styles.container}`, {
    [`${styles.disabled}`]: !!disabled,
  });

  return (
    <div className={classname}>
      <div className={styles.content}>
        <div className={styles.info}>
          <img className={styles.img} src={img} alt="" />
          <div className={styles.infoTitle}>
            <p className={styles.title} title={i18nTitle}>
              {title}
              {version}
              <span className={styles.tag}>
                {String(type) === '1'
                  ? intl.formatMessage(messages.wholePackage)
                  : intl.formatMessage(messages.patchPack)}
              </span>
              {/* {updateMethod < 2 && name !== 'supos' && cluster && operationType === 'upgrade' ? (
                <span className={styles.pgradeMethod}>
                  {updateMethod === 0
                    ? intl.formatMessage(messages.disturbanceFreeUpgrade)
                    : intl.formatMessage(messages.disturbanceUpgrade)}
                </span>
              ) : null} */}
            </p>
            <p className={styles.subTitle}>{subTitle}</p>
          </div>
        </div>

        {!isAvailable ? (
          isCurrent ? (
            <span className={styles.current}>{intl.formatMessage(messages.currentVersion)}</span>
          ) : (
            <span className={styles.disabled}>{checkDetail}</span>
          )
        ) : null}
        {statusRender()}
      </div>
      {!disabled && form && form.length !== 0 && (
        <Form name={name} wrappedComponentRef={formRef} dataSource={form} id={archiveId} />
      )}
    </div>
  );
};

export default Package;
